import { ApiService, toBodyModel, toModel, toModels } from '~/shared/api'
import {
  ArticleFilters,
  ArticleMainItem,
  ArticleMainSection,
  ArticleQueryResult,
} from '~/models/articles'
import { API_PREFIX } from '~/shared/const/request-services'

export class ArticleMainService extends ApiService {
  getMainPage(): Promise<ArticleMainSection[]> {
    return this.http.request({ url: `${API_PREFIX}/news/main` }).then(toModels(ArticleMainSection))
  }

  getFilters(params: Record<string, string> = {}): Promise<ArticleFilters> {
    return this.http
      .request({ url: `${API_PREFIX}/news/filters`, params })
      .then(toModel(ArticleFilters))
  }

  getNewsList(params: Record<string, string | number> = {}): Promise<ArticleQueryResult> {
    return this.http
      .request({
        url: `${API_PREFIX}/news/query`,
        params: { sort: '-published_at', 'page[size]': 21, ...params },
      })
      .then(toBodyModel(ArticleQueryResult))
  }

  getLatestNews(params: Record<string, string | number> = {}): Promise<ArticleMainItem[]> {
    return this.http
      .request({
        url: `${API_PREFIX}/news/query`,
        params: { sort: '-published_at', 'page[size]': 10, ...params },
      })
      .then(toModels(ArticleMainItem))
  }
}
